import dynamic from 'next/dynamic'

export const CatalogGridBannerAsync = dynamic(
	() => import('./catalog-grid-banner').then(({ CatalogGridBanner }) => CatalogGridBanner),
	{ ssr: false }
)
